import React, {useState, useEffect} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import { Link, useParams } from 'react-router-dom';
import {FaImage} from 'react-icons/fa';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { SERVER_API,ERP_URL } from '../../fileWithConstants';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/auth';
const ItemListingForFabric = () => {
  const { fb_id } = useParams();
  const [selectedFabric, setSelectedFabric] = useState([]);
  const [selectedFabricPhoto, setSelectedFabricPhoto] = useState("");
  const [auth, setAuth] = useAuth();
  const [fabrics, setFabrics] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(0);
  const [fabricDropdown, setFabricDropdown] = useState({});
  const [fabricsItems, setFabricsItems] = useState([]);

const Loader = () => (
  <div className="text-center my-4">
    <Spinner animation="border" role="status" variant="primary">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);

    const getAllItems = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-all-items`);
      if(data?.success){
        const all_items = data?.items;
        setItems(all_items);
      }
    } catch (error) {
      console.log(error)
    }
  }

   const getAllFabricList = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-list`);
      if(data?.success){
        const all_fabrics = data?.fabrics;
        setFabricDropdown(all_fabrics);
      }
    } catch (error) {
      //console.log(error)
    }
  }

  const getFabricItemsList = async(fb_id)=>{
    try {
      setLoading(true); 
      const {data} = await axios.get(`${SERVER_API}/api/v1/fabric/get-fabric-items-list/${fb_id}`);
      if(data?.success){
       /*  const all_fabrics_items = data?.items;
        setFabricsItems(all_fabrics_items);
        setLoading(false);  */

        const all_fabrics_items = data.items || [];
        const stockCounts = data.stockCounts || {};

        // merge stockCounts into each item
        const mergedItems = all_fabrics_items.map((item) => ({
          ...item,
          stock_count: stockCounts[item.item_id] || 0
        }));

        setFabricsItems(mergedItems);

        console.log('Merged Items:', mergedItems); // Debugging line
         setLoading(false); 

      }
      else{
        setFabricsItems([]);
        setLoading(false); 
      }
    } catch (error) {
      setLoading(false); 
      console.log(error)
    }
  }

useEffect(()=>{
   getAllItems();
   getAllFabricList();
},[]);

useEffect(() => {
    if (fabricDropdown?.length && fb_id) {
        getFabricItemsList(fb_id);
      // Find the fabric in the dropdown that matches the fb_id from the URL  
      const found = fabricDropdown.find(
        (fb) => fb.id === parseInt(fb_id) // match ID from URL
      );
      if (found)
          setSelectedFabric([found]); // wrap in array
          setSelectedFabricPhoto(found.fabric_photo);
    }
  }, [fabricDropdown, fb_id]);

  const handleItemChange = (selected) => {
      setSelectedFabric(selected);
     getFabricItemsList(selected?.[0]?.id);
      setSelectedFabricPhoto(selected?.[0]?.fabric_photo);
  };

  return (
    <Layout title={'Fabric List'}>
        <div className='container'>
            <h1 className='page-title'>Fabric List</h1>
              <div className="row justify-content-center">
                <div className="custom-inline-form search-filter-box">
                  <div className='col-md-12 form-box big-box item-big-box'>
                            <Typeahead
                                  name="fb_id"
                                  id="basic-typeahead-single"
                                  labelKey="name"
                                  onChange={handleItemChange}
                                  options={fabricDropdown}
                                  placeholder="Select Fabric"
                                  selected={selectedFabric}
                              />
                  </div>
                  <div className='col-md-4 form-box btn-box'> 
                  {selectedFabricPhoto && (
                              <Link to={`${SERVER_API}/uploads/fabrics/${selectedFabricPhoto}`} target='_blank'><img src={`${SERVER_API}/uploads/fabrics/${selectedFabricPhoto}`} alt={selectedFabricPhoto} width="30" /></Link>
                            )} &nbsp;&nbsp;
                  <Link className="btn btn-primary" onClick={()=>{ window.location.reload(); }}>Reset</Link>
                  </div>
                  </div>
              </div>
            
            <div className='col-md-12 m-t5'>
  <div className='table-box'>
    {loading ? (
      <Loader />
    ) : (
      <table className="table table-responsive table-hover table-sticky">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" className='text-start'>Item</th>
            <th scope="col">Category</th>
            <th scope="col">Element</th>
            <th scope="col">BOM QTY</th>
            <th scope="col">QTY in stock</th>
            <th scope="col">Possible QTY</th>
            <th scope="col">Stock Order Pending</th>
            <th scope="col">Stock QTY Pending</th>
            <th scope="col">Net Stock in hand</th>
            <th scope="col">Net Possible QTY</th>
          </tr>
        </thead>
        <tbody>
          {fabricsItems && fabricsItems.length > 0 ? (
            fabricsItems.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td className='text-start'>
                {item.item_name}&nbsp;
                {item.item_image && (
                  <Link to={`${ERP_URL}/uploads/item/${item.item_image}`} target='_blank'><FaImage/></Link>
                )}
                </td>
                <td>{item.category_name}</td>
                <td>
                  {item.e_name && item.e_name !== ''? item.e_name: item.fabric_slug}
                  </td>
                <td>
                 {(item.quantity)?.toLocaleString("en-US")}
                </td>
                <td>
                  {(item.balance)?.toLocaleString("en-US")}
                </td>
                <td>
                  {item.item_made}
                </td>
                <td>
                  {item.stock_count}
                </td>
                <td>
                  {(item.quantity*item.stock_count)?.toLocaleString("en-US")}
                </td>
                <td>
                 {((item.balance)-(item.quantity*item.stock_count))?.toLocaleString("en-US")}
                </td>
                <td>
                  {Math.floor((item.balance - item.quantity * item.stock_count) / item.quantity)?.toLocaleString("en-US")}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12" className="text-center text-muted">No fabrics found.</td>
            </tr>
          )}
        </tbody>
      </table>
    )}
  </div>
</div>
</div>

    </Layout>
  )
}

export default ItemListingForFabric